/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `performance` - performance
 * * `robustness` - robustness
 * * `fairness` - fairness
 * * `explainability` - explainability
 * @export
 */
export const IndicatorEnum = {
  performance: 'performance',
  robustness: 'robustness',
  fairness: 'fairness',
  explainability: 'explainability',
} as const;
export type IndicatorEnum = (typeof IndicatorEnum)[keyof typeof IndicatorEnum];

export function instanceOfIndicatorEnum(value: any): boolean {
  for (const key in IndicatorEnum) {
    if (Object.prototype.hasOwnProperty.call(IndicatorEnum, key)) {
      if ((IndicatorEnum as Record<string, IndicatorEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function IndicatorEnumFromJSON(json: any): IndicatorEnum {
  return IndicatorEnumFromJSONTyped(json, false);
}

export function IndicatorEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndicatorEnum {
  return json as IndicatorEnum;
}

export function IndicatorEnumToJSON(value?: IndicatorEnum | null): any {
  return value as any;
}
